import React from "react";

import dynamic from "next/dynamic";

import { HeaderNotifications } from "./HeaderNotifications";
import {
  WhoppahFullSize as WhoppahFullLogo,
  WhoppahSpark as WhoppahSparkLogo,
} from "@/assets/icons/Logo";
import { useAuth } from "@/auth";
// import { useUniqueVisit } from "@/common/hooks/useUniqueVisit";
import { cn } from "@/common/utils/css.utils";
import HeaderCart from "@/components/Header/HeaderCart";
import HeaderChat from "@/components/Header/HeaderChat";
import { HeaderCreateAd } from "@/components/Header/HeaderCreateAd";
import { HeaderFavorites } from "@/components/Header/HeaderFavorites";
import { HeaderLogo } from "@/components/Header/HeaderLogo";
import { HeaderMobileCategories } from "@/features/home-categories/components/HeaderMobileCategories";
import { HeaderSearchBox } from "@/features/search/components/search-box/HeaderSearchBox";
import NoSSR from "@mpth/react-no-ssr";

const HeaderAccountMobile = dynamic(() =>
  import("@/components/Header/HeaderAccountMobile").then(
    module => module.HeaderAccountMobile
  )
);

const MegaMenuMobile = dynamic(() =>
  import("@/components/mega-menu/mobile/MegaMenuMobile").then(
    module => module.MegaMenuMobile
  )
);

type HeaderMobileProps = {
  focused?: boolean;
};

const Logo = ({ focused }: { focused?: boolean }) => {
  const { isLoggedIn } = useAuth();

  return (
    <NoSSR>
      {focused ? (
        <HeaderLogo
          logo={
            isLoggedIn ? (
              <WhoppahSparkLogo className="h-6 self-center" />
            ) : (
              <WhoppahFullLogo className="h-6 w-auto" />
            )
          }
        />
      ) : (
        <HeaderLogo
          logo={
            isLoggedIn ? (
              <WhoppahSparkLogo className="h-7" />
            ) : (
              <WhoppahFullLogo className="h-7 w-auto" />
            )
          }
        />
      )}
    </NoSSR>
  );
};

export const HeaderMobile = ({ focused = false }: HeaderMobileProps) => {
  // const { isUnique, finalize: finalizeUniqueness } = useUniqueVisit({
  //   trackingKey: "mobile-header-search-by-image",
  //   maxRepeatCount: 3,
  // });

  const content = focused ? (
    <div className="flex flex-1 justify-center self-center">
      <div className="-mr-6 flex flex-1 justify-center">
        <Logo focused={focused} />
      </div>
      <MegaMenuMobile focused />
    </div>
  ) : (
    <>
      <div className="flex-1 self-center">
        <Logo focused={focused} />
      </div>
      <div className="flex items-center">
        <HeaderFavorites />
        <HeaderCart />
        <HeaderAccountMobile />
        <HeaderChat />
        <HeaderNotifications />
      </div>
      <HeaderCreateAd />
    </>
  );

  return (
    <div className="relative">
      <div
        className={cn(
          "flex flex-col space-y-3 border-b border-b-[#b0b0b0] border-opacity-40 bg-white px-4 md:hidden",
          focused ? "pb-4 pt-4" : "pb-2 pt-4"
        )}
      >
        <div className="relative flex items-center space-x-4">{content}</div>
        {!focused && (
          <>
            <div className="flex items-center space-x-3.5">
              <HeaderSearchBox />
              <MegaMenuMobile />
            </div>
            <HeaderMobileCategories />
          </>
        )}
      </div>
    </div>
  );
};
